import { ErrorOnLogoutException } from '@/domain/user/exceptions';

export const logoutUserExecute = async (platform, logoutUser) => {
  const {
    data: dataUser,
    status: statusLogout,
    responseCode,
    message,
  } = await logoutUser(platform);

  if (statusLogout === 200 && responseCode === '00') {
    localStorage.removeItem('token');
    return { responseCode, dataUser };
  } else {
    throw new ErrorOnLogoutException({ errorCode: responseCode, message });
  }
};
